import "./legal.css";

import React from "react";
import { Helmet } from "react-helmet";

import { CONTACT_DETAILS } from "../../utils/stateTypes";

const renderItem = (item) => {
  if (typeof item === "string") {
    return <li key={item}>{item}</li>;
  }
  //Item with a nested list
  return (
    <li key={item.text}>
      {item.text}
      <ul>
        {item.sub.map((sub) => <li key={sub}>{sub}</li>)}
      </ul>
    </li>
  );
};

const renderBlock = (block, i) => {
  if (block.h2) {
    return <h2 key={i}>{block.h2}</h2>;
  }
  if (block.meta) {
    return (
      <p
        key={i}
        className={"legal-meta"}
      >
        {block.meta.map((line) => (
          <React.Fragment key={line}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
    );
  }
  if (block.ul) {
    return <ul key={i}>{block.ul.map(renderItem)}</ul>;
  }
  if (block.ol) {
    return <ol key={i}>{block.ol.map(renderItem)}</ol>;
  }
  if (block.email) {
    return (
      <p key={i}>
        {block.email}
        <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
        .
      </p>
    );
  }
  return <p key={i}>{block.p}</p>;
};

const LegalPage = ({ page }) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>{`${page.metaTitle} | Janine Botha Attorneys`}</title>
      </Helmet>
      <header className={"legal-head bg-green"}>
        <div className={"container-narrow"}>
          <h1 className={"h-section"}>{page.title}</h1>
        </div>
      </header>
      <article className={"legal container-narrow"}>
        {page.blocks.map(renderBlock)}
      </article>
    </React.Fragment>
  );
};

export default LegalPage;
